import { UnifiedPane } from "./unified-pane";
import { ScoutConversation } from "./scout-api";

export function ScoutBuilderPane(props: {
  conversationId?: string; agentId?: string; context: Record<string, unknown>;
  onApplyDraft: (sessionId: string, context: Record<string, unknown>) => Promise<void>;
  onUndo: () => void; canUndo: boolean;
  onConversationChange: (conversation: ScoutConversation) => void;
}) {
  return <UnifiedPane studio initialConversationId={props.conversationId} agentId={props.agentId} context={props.context} onApplyDraft={props.onApplyDraft} onUndo={props.onUndo} canUndo={props.canUndo} onConversationChange={props.onConversationChange} />;
}
